module.exports = __webpack_public_path__ + "media/base/arrow-up-5a2872ff.svg";